module.exports = __webpack_public_path__ + "img/Sun-and-Clouds-Loading-Animation-css.2521e69b.svg";